import { Button, CircularProgress, Modal, Paper } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';
import UserLookup from '../userLookup/UserLookup';
import UsersContext from './UsersContext';


const Container = styled.div`

    display:flex;
    align-items:center;
    justify-content:center;

`;

const PaperContainer = styled.div`

    display:flex;
    padding-left:40px;
    height:340px;
    width:700px;
    justify-content:space-around;
    flex-direction:column;

`;

const Title = styled.div`
    color: rgba(0, 0, 0, 0.87);
    font-family: Roboto;
    font-size: 20px;
    font-weight: 500;
    letter-spacing: 0.25px;
    line-height: 24px;
    text-align: left;
`;


const BottomButtonsContainer = styled.div`

    display:flex;
    width:200px;
    align-items:flex-start;
    justify-content:space-between;

`;

class UsersAddModal extends React.Component {

    constructor(props)
    {
        super(props);
        const {aboutCurrentUser = {}} = props;
        let userToAdd = null;
        if(aboutCurrentUser.IsImpersonating)
        {
            userToAdd = {name:`${aboutCurrentUser.LastName}, ${aboutCurrentUser.FirstName}`, bun:aboutCurrentUser.bun}
        }
        this.state = {userToAdd};
    }

    render()
    {   
        return <UsersContext.Consumer>{context=> this.renderContent(context)}</UsersContext.Consumer>

    }

    renderContent(context) {
        const {loading, aboutCurrentUser= {}} = this.props;
     return(
        <>
        {context.addingUser &&
            <Modal open={context.addingUser} >
               <Container style={{height:window.innerHeight}}>
                        <Paper>
                            <PaperContainer>
                                <Title>Add User</Title>

                                {!loading &&
                                    <React.Fragment>
                                        <UserLookup
                                            usersToExclude={context.users && context.users.users ? context.users.users : []}
                                            onUserSelected={userToAdd=>this.setState({userToAdd})}
                                            selectedUser={this.state.userToAdd ? this.state.userToAdd : null}
                                        />
                                        <BottomButtonsContainer>
                                            <Button 
                                                variant="outlined" 
                                                color="primary" 
                                                onClick={() => { 
                                                    context.updateAddingUser(false);
                                                    this.setState({userToAdd:null});
                                                }}>
                                                Cancel
                                            </Button>
                                            <Button variant="outlined"
                                                    disabled={!this.state.userToAdd}
                                                    color="primary" 
                                                    onClick={() => {
                                                        context.updateAddingUser(false);
                                                        this.setState({userToAdd:null});
                                                        context.addUser(this.state.userToAdd);

                                                    
                                                    }}  >
                                                Add
                                            </Button>
                                        </BottomButtonsContainer>
                                    </React.Fragment>
                                }
                                {!!loading &&
                                    <CircularProgress/>
                                }
                                
                            </PaperContainer>
                        </Paper>
                </Container>       
            </Modal>
        }
        </>
      )
    }
}

export default UsersAddModal;